import { Fetcher } from '@this/src/util';
import React, { useState } from 'react';
import { Button } from '@this/shared/ui/inputs/button';
import type User2 from '@this/domain/user/user2';
import ExpensesMain from '../main/main';

type AccountEditUser = Pick<User2, 'expensesSlackConnected'>;

interface Props {
  user: AccountEditUser | null | undefined;
}

const AccountEdit: React.FC<Props> = ({ user }) => {
  const [disconnecting, setDisconnecting] = useState(false);

  if (!user) return null;

  const disconnectSlack = async () => {
    setDisconnecting(true);
    try {
      await Fetcher.delete('/slackapp/expenses/remove_slack_auth');
      window.location.assign('/aiexpense/account/edit');
    } finally {
      setDisconnecting(false);
    }
  };

  return (
    <ExpensesMain title="アカウント設定">
      <div style={{ maxWidth: '600px' }}>
        <section style={{ marginBottom: '32px' }}>
          <h2
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '16px',
              borderBottom: '1px solid #e0e0e0',
              paddingBottom: '8px'
            }}
          >
            Slack連携
          </h2>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '8px'
            }}
          >
            <span style={{ fontSize: '14px' }}>経費精算Slack連携</span>
            {!user.expensesSlackConnected ? (
              <Button isExternal href="/slackapp/expenses/start_slack_auth" size="small">
                Slackと接続する
              </Button>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '14px', color: '#4caf50' }}>連携済み</span>
                <Button loading={disconnecting} onClick={disconnectSlack} size="small">
                  連携解除
                </Button>
              </div>
            )}
          </div>
        </section>
      </div>
    </ExpensesMain>
  );
};

export default AccountEdit;
